export default {
  SUGGESTED_OR_REQUESTED_APPROVAL: "1",
  APPROVED: "2",
  REJECTED: "3",
  CANCELED: "4",
  PRE_APPROVAL: "5",
} as const;
